import { BarChart3 } from 'lucide-react';

export const RevenueChart = () => {
  return (
    <div className="bg-white rounded-3xl p-6 shadow-soft">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[17px] font-semibold text-[var(--text-primary)]">Revenue Overview</h2>
        <a
          href="#"
          className="text-[13px] font-semibold text-[var(--text-accent)] hover:text-[var(--text-accent)] transition-colors"
        >
          View Details →
        </a>
      </div>

      {/* Chart Placeholder */}
      <div className="h-[300px] rounded-2xl bg-[var(--bg-base)] flex flex-col items-center justify-center">
        <BarChart3 className="w-16 h-16 text-[var(--text-muted)]" strokeWidth={1.5} />
        <p className="text-[14px] text-[var(--text-muted)] mt-3">Chart visualization would appear here</p>
      </div>
    </div>
  );
};